module.exports = __webpack_public_path__ + "static/img/icon_case_1.71862ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_case_1.png
// module id = bJNT
// module chunks = 0